import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/base/base.component';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  ProviderClass,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-platform-intl-beneficiary-added',
  templateUrl: './intl-beneficiary-added.component.html',
})
export class IntlBeneficiaryAddedComponent extends BaseComponent implements OnInit {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  public content = '';
  public templateFunction: HandlebarsTemplateDelegate<any>;
  public baseHandleBarModel: any;
  public colorTextAlignStyle: baseCssConfigStyle;

  constructor(
    private store: Store,
    public accountService: AccountService,
    private countriesCurrenciesService: CountriesCurrenciesService,
    public dataIn: ProviderClass<any>,
    private configService: ConfigService,
    private iconCacheService: IconCacheService,
  ) {
    super();
    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri;
    }
  }

  ngOnInit() {
    this.initHandleBars();
  }

  private initHandleBars() {
    this.content = this.attri?.widgetProperties?.textContent;
    this.templateFunction = Handlebars.compile(this.content);
    buildHandleBarModel(this.store, this.content, this.countriesCurrenciesService, this.iconCacheService)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.baseHandleBarModel = this.templateFunction(model);
      });

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_UNDERLINE,
      BaseCssProperties.BOX_SHADOW,
      BaseCssProperties.TEXT_FONT_STYLE,
      BaseCssProperties.FONT_WEIGHT,
    ]);
    this.colorTextAlignStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.COLOR,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_BOLD,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_UNDERLINE,
      BaseCssProperties.V_ALIGN,
      BaseCssProperties.TEXTALIGN,
    ]);
  }
}
